import React from 'react'

const TeamStandingsHeader = ({numberOfFish = 0, hideFish = false, showDays = false, days = 0, day,team_record_total}) => {

  const getFishHeaders = (numberOfFish) => {
    
    /*
    console.log('numberOfFish values set::',numberOfFish );
    console.log('day value passed:::',day);
    console.log('team record total value passed:::', team_record_total);
    */

    
    //If day value passed is 1 show rank,team header 

    if(!numberOfFish) return <></>

    let fishHeaders = [];
    for (let i = 0; i < numberOfFish; i++) {
      if( numberOfFish > 5){
        fishHeaders.push(<th style={{whiteSpace: 'nowrap'}} key={`${day}header${i}`}>F{i+1}</th>)
      }else{
        fishHeaders.push(<th style={{whiteSpace: 'nowrap'}} key={`${day}header${i}`}>Fish {i+1}</th>)
      }
      
    }

    // console.log(`fish headers = ${fishHeaders.length}`)
    return fishHeaders
  }
  
  //console.log('Days value passed for header::', days);

  const getTeamFishHeaders = (team_record_total) =>{

    if(!team_record_total) return <></>

    console.log('team_record_total value passed:::',team_record_total);

    let temp_fishHeaders = [];
 
   
    for (let i = 0; i < team_record_total; i++) {
      temp_fishHeaders.push(<th style={{whiteSpace: 'nowrap'}} key={`${day}header${i}`}></th>)
    }
    return temp_fishHeaders
  }
  const fishHeaders = getFishHeaders(numberOfFish)

  const teamFishHeaders = getTeamFishHeaders(team_record_total)
  
  const header = hideFish 
    ? 
    <thead className="standings-header">
        <tr className="standings-fish-header">
          <th>Rk</th>
          {
                day === 1 ?
                <th className="team-standings-angler">Team</th>
                : <th className="standings-angler">Angler</th>
          }
          {
            teamFishHeaders
          }
         
          <th>Total</th>
        </tr>
    </thead>


    : <thead className="standings-header">
        <tr className="standings-fish-header">
          <th>Rk</th>
          {
                day === 1 ?
                <th className="team-standings-angler">Team</th>
                : <th className="standings-angler">Angler</th>
          }
           
          {     
               day === 1 ?
                
               teamFishHeaders
               :fishHeaders
          }

          <th>Total</th>
        </tr>
      </thead>

  return ( 
  <>
    {header}
  </> 
  )
}

export default TeamStandingsHeader